/**
 * Choices about how the demos are played, remembered per browser.
 *
 * Off by default, deliberately. These modes are asking whether someone can
 * judge a thing by eye, and a ladder of earlier attempts answers a good deal
 * of that for them — knowing the beam tipped left last time turns a judgement
 * into a bisection. The option exists because it is worth comparing the two
 * in testing, not because it is the default experience.
 */

export const SHOW_ATTEMPTS_KEY = 'angle.demos.showAttempts';

export function readShowAttempts() {
  try {
    return localStorage.getItem(SHOW_ATTEMPTS_KEY) === 'true';
  } catch (e) {
    return false;
  }
}

export function writeShowAttempts(on) {
  try {
    localStorage.setItem(SHOW_ATTEMPTS_KEY, on ? 'true' : 'false');
  } catch (e) {}
}
